export const PREVIEW_INSPECTOR_COLOR = '#2563eb';
